import { render } from "./LayoutSimple.vue?vue&type=template&id=a788cd88"
import script from "./LayoutSimple.vue?vue&type=script&lang=js"
export * from "./LayoutSimple.vue?vue&type=script&lang=js"

import "./LayoutSimple.vue?vue&type=style&index=0&id=a788cd88&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__